import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { StorageKey, StorageUtils } from 'utils/local-storage';

interface Props {
  children: ReactElement;
}

const hasSession = () => {
  try {
    return !!StorageUtils.getObject(StorageKey.SESSION)?.accessToken;
  } catch {
    return false;
  }
};

/**
 * Bọc các trang xác thực công khai (/login, /register, /forgot-password, /request-access):
 * đã có phiên thì về thẳng Tổng quan thay vì hiện lại form.
 */
const PublicOnlyRoute = ({ children }: Props) => {
  if (hasSession()) return <Navigate to="/" replace />;
  return children;
};

export default PublicOnlyRoute;
